// extracted by mini-css-extract-plugin
module.exports = {"actionWrapper":"BirthDateFormCtas_actionWrapper__qnolN","ageConfirmationButton":"BirthDateFormCtas_ageConfirmationButton__ckQO8"};